const BASE = process.env.VUE_APP_API_URL || '/api';

export function api(path: string): string {
  return `${BASE.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
}
